/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutTargetType } from './rolloutTargetType';


/**
 * Specification to target Org with OAuth App targets.
 */
export interface OrgWithOAuthAppsTargetSpec { 
    type?: RolloutTargetType;
}
export namespace OrgWithOAuthAppsTargetSpec {
}


